var map = {
	"./AD.svg": 4099,
	"./AE.svg": 4443,
	"./AF.svg": 8333,
	"./AG.svg": 8198,
	"./AI.svg": 1296,
	"./AL.svg": 472,
	"./AM.svg": 5471,
	"./AO.svg": 8472,
	"./AR.svg": 5065,
	"./AS.svg": 7451,
	"./AT.svg": 6377,
	"./AU.svg": 3636,
	"./AW.svg": 7034,
	"./AX.svg": 6898,
	"./AZ.svg": 7630,
	"./BA.svg": 1951,
	"./BB.svg": 8875,
	"./BD.svg": 2765,
	"./BE.svg": 4169,
	"./BF.svg": 4207,
	"./BG.svg": 4010,
	"./BH.svg": 9901,
	"./BI.svg": 9128,
	"./BJ.svg": 6814,
	"./BL.svg": 147,
	"./BM.svg": 3410,
	"./BN.svg": 8586,
	"./BO.svg": 2984,
	"./BR.svg": 4683,
	"./BS.svg": 5943,
	"./BT.svg": 4832,
	"./BV.svg": 2959,
	"./BW.svg": 4501,
	"./BY.svg": 6887,
	"./BZ.svg": 2925,
	"./CA.svg": 81,
	"./CC.svg": 4319,
	"./CD.svg": 7672,
	"./CF.svg": 5502,
	"./CG.svg": 1820,
	"./CH.svg": 433,
	"./CI.svg": 2677,
	"./CK.svg": 5659,
	"./CL.svg": 5218,
	"./CM.svg": 8252,
	"./CN.svg": 4576,
	"./CO.svg": 2541,
	"./CR.svg": 6831,
	"./CU.svg": 1975,
	"./CV.svg": 1763,
	"./CW.svg": 6494,
	"./CX.svg": 7147,
	"./CY.svg": 1471,
	"./CZ.svg": 7786,
	"./DE.svg": 7675,
	"./DJ.svg": 1721,
	"./DK.svg": 3356,
	"./DM.svg": 3986,
	"./DO.svg": 5512,
	"./DZ.svg": 8831,
	"./EC.svg": 4166,
	"./EE.svg": 968,
	"./EG.svg": 3987,
	"./ER.svg": 156,
	"./ES.svg": 6739,
	"./ET.svg": 7657,
	"./EU.svg": 4199,
	"./FI.svg": 7537,
	"./FJ.svg": 2332,
	"./FK.svg": 9812,
	"./FM.svg": 225,
	"./FO.svg": 2974,
	"./FR.svg": 4304,
	"./GA.svg": 6613,
	"./GB-ENG.svg": 4053,
	"./GB-NIR.svg": 7682,
	"./GB-SCT.svg": 9908,
	"./GB-WLS.svg": 9870,
	"./GB-ZET.svg": 5738,
	"./GB.svg": 5123,
	"./GD.svg": 4831,
	"./GE.svg": 5025,
	"./GF.svg": 6748,
	"./GG.svg": 8745,
	"./GH.svg": 3372,
	"./GI.svg": 4649,
	"./GL.svg": 2076,
	"./GM.svg": 796,
	"./GN.svg": 9232,
	"./GP.svg": 1848,
	"./GQ.svg": 402,
	"./GR.svg": 9405,
	"./GS.svg": 9809,
	"./GT.svg": 5577,
	"./GU.svg": 8509,
	"./GW.svg": 2975,
	"./GY.svg": 3668,
	"./HK.svg": 6081,
	"./HM.svg": 9804,
	"./HN.svg": 9546,
	"./HR.svg": 7540,
	"./HT.svg": 3546,
	"./HU.svg": 5116,
	"./ID.svg": 1790,
	"./IE.svg": 5491,
	"./IL.svg": 6634,
	"./IM.svg": 2105,
	"./IN.svg": 4370,
	"./IO.svg": 3114,
	"./IQ.svg": 2803,
	"./IR.svg": 2143,
	"./IS.svg": 1198,
	"./IT.svg": 8102,
	"./JE.svg": 1279,
	"./JM.svg": 7132,
	"./JO.svg": 5111,
	"./JP.svg": 3523,
	"./KE.svg": 7170,
	"./KG.svg": 8354,
	"./KH.svg": 6458,
	"./KI.svg": 1481,
	"./KM.svg": 5080,
	"./KN.svg": 1768,
	"./KP.svg": 2231,
	"./KR.svg": 6119,
	"./KW.svg": 521,
	"./KY.svg": 4160,
	"./KZ.svg": 9070,
	"./LA.svg": 8272,
	"./LB.svg": 7923,
	"./LC.svg": 6726,
	"./LGBT.svg": 3419,
	"./LI.svg": 366,
	"./LK.svg": 2024,
	"./LR.svg": 1282,
	"./LS.svg": 1069,
	"./LT.svg": 7220,
	"./LU.svg": 7842,
	"./LV.svg": 2553,
	"./LY.svg": 8435,
	"./MA.svg": 5417,
	"./MC.svg": 300,
	"./MD.svg": 1825,
	"./ME.svg": 2102,
	"./MG.svg": 2156,
	"./MH.svg": 6630,
	"./MK.svg": 7244,
	"./ML.svg": 2370,
	"./MM.svg": 4954,
	"./MN.svg": 5334,
	"./MO.svg": 5252,
	"./MP.svg": 530,
	"./MQ.svg": 9488,
	"./MR.svg": 1318,
	"./MS.svg": 8342,
	"./MT.svg": 635,
	"./MU.svg": 7927,
	"./MV.svg": 8423,
	"./MW.svg": 1289,
	"./MX.svg": 2070,
	"./MY.svg": 7146,
	"./MZ.svg": 6975,
	"./NA.svg": 938,
	"./NC.svg": 5093,
	"./NE.svg": 8059,
	"./NF.svg": 2811,
	"./NG.svg": 9410,
	"./NI.svg": 5454,
	"./NL.svg": 7426,
	"./NO.svg": 4088,
	"./NP.svg": 6052,
	"./NR.svg": 8109,
	"./NU.svg": 9932,
	"./NZ.svg": 7480,
	"./OM.svg": 6215,
	"./PA.svg": 8733,
	"./PE.svg": 8239,
	"./PF.svg": 2636,
	"./PG.svg": 5187,
	"./PH.svg": 8241,
	"./PK.svg": 8725,
	"./PL.svg": 7612,
	"./PM.svg": 3050,
	"./PN.svg": 3738,
	"./PR.svg": 3702,
	"./PS.svg": 8671,
	"./PT.svg": 4995,
	"./PW.svg": 5707,
	"./PY.svg": 1087,
	"./QA.svg": 5542,
	"./RE.svg": 2767,
	"./RO.svg": 6919,
	"./RS.svg": 4682,
	"./RU.svg": 105,
	"./RW.svg": 4737,
	"./SA.svg": 3602,
	"./SAMI.svg": 1883,
	"./SB.svg": 5044,
	"./SC.svg": 7954,
	"./SD.svg": 6728,
	"./SE-JAM.svg": 5843,
	"./SE-SKA.svg": 4901,
	"./SE-VAS.svg": 8270,
	"./SE.svg": 4883,
	"./SEFI.svg": 9983,
	"./SG.svg": 415,
	"./SI.svg": 3513,
	"./SJ.svg": 7509,
	"./SK.svg": 1738,
	"./SL.svg": 8238,
	"./SM.svg": 5575,
	"./SN.svg": 7544,
	"./SO.svg": 1642,
	"./SR.svg": 4184,
	"./SS.svg": 1030,
	"./ST.svg": 7622,
	"./SV.svg": 5271,
	"./SX.svg": 5450,
	"./SY.svg": 3459,
	"./SZ.svg": 605,
	"./TC.svg": 7552,
	"./TD.svg": 2147,
	"./TF.svg": 2459,
	"./TG.svg": 3063,
	"./TH.svg": 4920,
	"./TJ.svg": 8090,
	"./TK.svg": 4167,
	"./TL.svg": 4885,
	"./TM.svg": 1241,
	"./TN.svg": 657,
	"./TO.svg": 7265,
	"./TORN.svg": 3856,
	"./TR.svg": 1734,
	"./TT.svg": 4029,
	"./TV.svg": 8840,
	"./TW.svg": 6978,
	"./TZ.svg": 6111,
	"./UA.svg": 3040,
	"./UG.svg": 2164,
	"./UM.svg": 8247,
	"./US-CA.svg": 7069,
	"./US.svg": 862,
	"./UY.svg": 7777,
	"./UZ.svg": 7730,
	"./VA.svg": 1239,
	"./VC.svg": 3537,
	"./VE.svg": 9214,
	"./VG.svg": 8075,
	"./VI.svg": 5125,
	"./VN.svg": 3331,
	"./VU.svg": 254,
	"./WF.svg": 9462,
	"./WS.svg": 6514,
	"./WW-AFR.svg": 2770,
	"./WW-ASI.svg": 3529,
	"./WW-AUS.svg": 7182,
	"./WW-EUR.svg": 9831,
	"./WW-NAM.svg": 6462,
	"./WW-SAM.svg": 5558,
	"./WW.svg": 7496,
	"./XK.svg": 8648,
	"./YE.svg": 9385,
	"./YT.svg": 1413,
	"./ZA.svg": 7261,
	"./ZM.svg": 9925,
	"./ZW.svg": 4785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7829;